/**
 * Maps the social-connect callback query onto a toast.
 *
 * A live row for that platform is success even when the one-use callback
 * came back as expired or cancelled - the first hop already wrote the
 * connection; the second hop must not paint an error banner over it.
 */

const RESULT: Record<string, { ok: boolean; text: string }> = {
  linked: { ok: true, text: "Account connected." },
  taken: {
    ok: false,
    text: "That account is already connected to another creator. "
        + "An ownership transfer has to be reviewed before it can move.",
  },
  expired: { ok: false, text: "That connect link expired. Start again from this page." },
  unavailable: { ok: false, text: "The connection service could not be reached. Nothing was linked." },
  cancelled: { ok: false, text: "No new account was authorized. You can try again." },
  failed: { ok: false, text: "The connection could not be completed." },
  permissions: {
    ok: false,
    text: "That platform needs every permission ticked. Connect again and accept them all - especially on TikTok.",
  },
  no_channel: {
    ok: false,
    text: "That Google account has no YouTube channel we can connect. Pick the Brand Account, or create a channel, then try again.",
  },
};

const LIVE = new Set(["CONNECTED", "EXPIRING", "INSUFFICIENT_PERMISSION"]);

export function connectResultFeedback(
  result: string | null,
  platform: string | null,
  connections: { platform: string; connection_state: string }[],
): { kind: "ok" | "error" | "none"; text: string } {
  if (!result || !RESULT[result]) return { kind: "none", text: "" };
  const bit = RESULT[result];
  const live = platform
    ? connections.some((r) => r.platform === platform && LIVE.has(r.connection_state))
    : connections.some((r) => LIVE.has(r.connection_state));
  if (bit.ok || live) {
    return { kind: "ok", text: bit.ok ? bit.text : "Account connected." };
  }
  return { kind: "error", text: bit.text };
}
